import React from "react";
import { useSelector } from "react-redux";
import { Field } from "redux-form";

import { ReduxControls, ProgressIndicator } from "rhombus-react";

import { ASSET_TYPES } from "utils/constants";
import { formatBytes } from "utils/common";

import { useSocialFields } from "social/formats/utils";

import AssetSelect from "social/AssetSelect";

import { MAX_IMAGE_BYTES, MAX_LENGTH_LANDING_PAGE } from "./consts";

const IMAGE_ACCEPT = ".jpg, .jpeg, .png, .gif";

const FILE_SIZE_REQUIREMENT = { name: "File Size:", description: `${formatBytes(MAX_IMAGE_BYTES)} Maximum` };
const FILE_TYPE_REQUIREMENT = { name: "File Types:", description: IMAGE_ACCEPT };

export default function FacebookImageVertical(props){
	const {
		libraryId,
		navigationActions,
	} = props;

	const isLoading = useSelector(state => state.social?.facebookPages?.isLoading);

	const baseFields = {
		image: {
			name: "image",
			label: "Image",
			className: "full-width",
			assetType: ASSET_TYPES.IMAGE,
			component: AssetSelect,
			requirements: [
				FILE_SIZE_REQUIREMENT,
				FILE_TYPE_REQUIREMENT,
				{ name: "Dimensions:", description: "254x133 pixels or larger required, 1080x1920 or larger recommended" }
			],
			required: true,
			accept: IMAGE_ACCEPT,
			tip: {
				direction: "top",
				description: "At least 600x600 for better placement compatibility",
			},
			libraryId,
			navigationActions,
		},
		headline: {
			name: "headline",
			label: "Headline",
			className: "full-width",
			placeholder: "Enter a short headline",
			tip: {
				description: "May get truncated after 40 characters",
				direction: "right",
			},
			component: ReduxControls.Input,
		},
		primaryText: {
			name: "primaryText",
			label: "Primary Text",
			className: "full-width",
			placeholder: "Tell people what your creative is about",
			tip: {
				description: "May get truncated after 125 characters",
				direction: "right",
			},
			component: ReduxControls.Input,
			type: "textarea",
		},
		landingPage: {
			name: "landingPage",
			label: "Landing Page",
			className: "full-width",
			placeholder: "https://www.example.com",
			component: ReduxControls.Input,
			required: true,
			charMax: MAX_LENGTH_LANDING_PAGE,
			showCharCount: true,
		},
		displayLink: {
			name: "displayLink",
			label: "Display Link",
			className: "half-width",
			placeholder: "Enter link text to be displayed",
			component: ReduxControls.Input,
		},
	};

	const fieldProps = useSocialFields(baseFields, props);

	return (
		<>
			<ProgressIndicator isLoading={isLoading} />
			<div className="fields">
				{fieldProps.map((properties) => {
					return <Field key={properties.name} {...properties} />;
				})}
			</div>
		</>
	);
}

FacebookImageVertical.displayName = "FacebookImageVerticalPlacement";
